import { t } from "i18next";
import React from "react";
import FallbackComponent from "./FallbackComponent";

const ErrorFallbacks = ({ statusCode }) => {
  // ERROR FALLBACK CONTENT OBJECT
  const errorMessages = {
    404: {
      imageName: "brokenPencilThumbnail.svg",
      heading: t("components.errorFallbacks.index.oopsText404", "Ooops..!"),
      text: t(
        "components.errorFallbacks.index.pageNotFoundText",
        "Page not found, please come back later"
      ),
      // buttonText: t("components.errorFallbacks.index.goBackText", "Go Back"),
    },
    500: {
      imageName: "brokenPencilThumbnail.svg",
      heading: t("components.errorFallbacks.index.oopsText500", "Ooops..!"),
      text: t(
        "components.errorFallbacks.index.somethingWentWrongText",
        "Something went wrong, please come back later"
      ),
      // buttonText: t(
      //   "components.errorFallbacks.index.tryAgainText500",
      //   "Try Again"
      // ),
    },
    504: {
      imageName: "noInternetThumbnail.svg",
      heading: t("components.errorFallbacks.index.aaahText", "Aaaah..!"),
      text: t(
        "components.errorFallbacks.index.noInternetText",
        "Could not connect to the internet. Please check your network."
      ),
      // buttonText: t(
      //   "components.errorFallbacks.index.tryAgainText504",
      //   "Try Again"
      // ),
    },
    200: {
      heading: "Loading...",
    },

    1000: {
      imageName: "brokenPencilThumbnail.svg",
      heading: t("components.errorFallbacks.index.oopsText500", "Ooops..!"),
      text: t(
        "components.errorFallbacks.index.somethingWentWrongText",
        "Something went wrong, please come back later"
      ),
      buttonText: t(
        "components.errorFallbacks.index.tryAgainText1000",
        "Try Again"
      ),
    },
  };

  // FUNCTION TO GET ERROR MESSAGE OBJECT FROM STATUS CODE
  const getErrorMessage = (statusCode) => {
    if (errorMessages[statusCode]?.heading) {
      return errorMessages[statusCode];
    }
    return errorMessages[500];
  };

  return <FallbackComponent errorMessage={getErrorMessage(statusCode)} />;
};

export default ErrorFallbacks;
